import React from "react";
import Navbar from "../Component/navbar";
import AboutUs from "../Component/aboutUs";
import ExpertTrainner from "../Component/experTrainner";
import MemberShip from "../Component/memberShip";
import WhyChose from "../Component/whyChose";
import Classes from "../Component/Classes";
import Rattings from "../Component/Rattings";
import ContactUs from "../Component/contactUs";
import Footter from "../Component/footter";
import { Link, useHistory } from "react-router-dom";
import SpecialOffer from "../Component/specialOffer";

function Main() {
  const navigate = useHistory();
  return (
    <div className="w-full h-full bg-black aling-center flex flex-col">
      <div className="fixed top-0 w-full h-auto z-40">
        <Navbar />
      </div>
      {/* video and text */}
      <video
        className="w-full h-[500px] sm:h-[700px] md:h-[1080px] object-cover absolute top-0 left-0 z-0"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="/video.mp4" type="video/mp4" />
      </video>
      <div className="w-full h-[500px] sm:h-[700px] md:h-[1080px] absolute top-0 left-0 z-10 flex items-center justify-center bg-black bg-opacity-70"></div>

      <div className="w-full h-[500px] sm:h-[700px] md:h-[1080px] absolute top-0 left-0 z-30 flex items-center justify-center flex-col ">
        <div className="text-center">
          <p className="text-white text-3xl  sm:text-4xl  2xl:text-[80px] md:text-[50px]   lg:text-[65px] font-bold mt-20 mb-2 md:mb-4 lg:mb-12 font-montserrat ">
            <span className="text-red">FIT STREAK</span> WHERE
          </p>
          <p className="text-white text-3xl  sm:text-4xl   2xl:text-[80px] md:text-[50px] lg:text-[65px] font-bold font-montserrat ">
            STRENGTH MEETS STAMINA
          </p>
        </div>
        {/* <button
          className="bg-red p-2  px-6 sm:px-6 md:px-9 lg:px-12 sm:py-2 md:py-4  mt-2 sm:mt-4 md:mt-10 rounded-[8px] text-white font-semibold z-50  sm:text-lg lg:text-2xl xl:text-3xl   "
          onClick={() => {
            navigate.push("/joinNow");
          }}
        >
          {" "}
          JOIN NOW
        </button> */}
      </div>
      {/* About Us Content  */}
      <div
        className="w-full  bg-[#1c1c1c] aling-center flex relative z-20 md:mt-[1080px] sm:mt-[700px] mt-[500px]"
        id="Aboutus"
      >
        <AboutUs />
      </div>
      {/*Expert Trainner Code  */}
      <div
        className="w-full h-auto bg-[#161616] aling-center flex relative z-20  "
        id="trainner"
      >
        <ExpertTrainner />
      </div>
      <div
        className="w-full h-auto bg-[#1c1c1c] aling-center flex relative z-20 flex-col pb-10 "
        id="MemberShip"
      >
        <MemberShip />
        <div
          className="mt-3 mb-6 sm:mb-0 md:mt-4 flex flex-col md:flex-row w-full h-auto m-auto items-center overflow-hidden relative"
          id="specialOffer"
        >
          {/* Text Section */}
          <div className="flex flex-col p-2 xxs:px-2 px-4 sm:px-4 sm:pt-8 w-full lg:w-max  mt-[2%]  text-white md:mb-5 lg:mb-2 xl:mb-2 2xl:mb-10 sm:ml-[10%] z-10 text-left">
            <h1 className="xxs:text-base text-xl sm:text-2xl md:text-lg lg:text-xl xl:text-2xl 2xl:text-3xl font-semibold text-left sm:ml-3">
              Special Offer
            </h1>
            <h2 className="xxs:text-[50px] text-[40px] sm:text-[75px] md:text-[65px] lg:text-[80px] xl:text-[60px] 2xl:text-[126px] font-hemihead text-red p-0 leading-[0.8]">
              Register for Only 1 Rupee
            </h2>
            {/* <h2 className='xxs:text-[25px] text-[30px] sm:text-[45px] md:text-[30px] lg:text-[35px] xl:text-[50px] 2xl:text-[60px] font-semibold p-0 leading-[1]'>
                            ON REGISTRATION
                        </h2> */}
            <br></br>
            <h2 className="xxs:text-[13px] text-[15px] sm:text-[20px] md:text-[16px] lg:text-[18px] xl:text-[25px] 2xl:text-[30px] font-semibold">
              Offer valid till 30 March, 2025
            </h2>
            {/* <button
              className="py-2 px-6 bg-red xxs:text-sm text-center mt-8 sm:mt-6 lg:mt-10 xl:mt-12 2xl:mt-8 w-max rounded-[5px] text-base font-semibold text-white lg:text-lg lg:mb-6 xl:mb-6 xl:text-2xl"
              onClick={() => {
                navigate.push("/joinNow");
              }}
            >
              JOIN NOW
            </button> */}
          </div>

          {/* Image Section as Background */}
          <div
            className="absolute top-0 left-0 w-full h-full bg-cover bg-center"
            style={{ backgroundImage: 'url("/images/banner.png")' }}
          />
        </div>
      </div>
      <div
        className="w-full h-auto bg-[#161616] aling-center flex relative z-20 py-10  "
        id="Whyus"
      >
        <WhyChose />
      </div>
      <div
        className="w-full h-auto bg-[#1c1c1c] aling-center flex relative z-20  "
        id="Classes"
      >
        <Classes />
      </div>
      <div className="w-full h-auto bg-[#161616] aling-center flex relative z-20   ">
        <Rattings />
      </div>
      <div
        className="w-full h-auto bg-[#1c1c1c] aling-center flex relative z-20   "
        id="ContactUs"
      >
        <ContactUs />
      </div>
      {/* <div className='w-full h-auto bg-white aling-center flex relative z-20   ' id='specialOffer'>
                <SpecialOffer   />
            </div> */}
      <div className="w-full h-auto bg-[#161616] aling-center flex relative z-20   ">
        <Footter />
      </div>
    </div>
  );
}

export default Main;
